import common from '../common'

export default {
    list(params) {
      return common.get('/rocheManage/meeting/pubMeeting/myMeetingTaskList',params);
    },

    apprvoal(params) {
      return common.put('/rocheManage/meeting/pubMeeting/myTaskMeetingSubmit',params);
    },

    queryMainTask(params) {
      return common.get('/rocheManage/meeting/pubMeeting/myTaskMeetingSummary',params);
    },

    exportXls(params) {
      return common.get('/rocheManage/meeting/pubMeeting/myMeetingTaskExportXls', params, {responseType: 'blob'});
    },
}


// WEBPACK FOOTER //
// ./src/api/meetingplan/task.js